import ReactApexChart from "react-apexcharts";
import styles from "./styles.module.scss";
import React from "react";
import { IProjectImplementeds } from "../../../../@types/project/project-implemented.type";
import { formatCurrency } from "../../../../utils/formatCurrency";

interface LineChartImplementedProps {
  projectImplemented: IProjectImplementeds[],
  graphType: number,
}

export const LineChartImplemented: React.FC<LineChartImplementedProps> = ({projectImplemented, graphType}) => { 
  function costGraph(itens: IProjectImplementeds[], type: string){
    return itens.map((x) => {
      switch (type) {
        case "name":
          return x.name
          break;
        case "budget":
          return x.budgetPrice
          break;
        case "planned":
          return x.plannedPrice
          break;
        case "implemented":
          return x.implementedPrice
          break;
        default:
          break;
      }
    })
  };

  function hourGraph(itens: IProjectImplementeds[], type: string){
    return itens.map((x) => {
      switch (type) {
        case "name":
          return x.name
          break;
        case "budget":
          return x.budgetHours
          break;
        case "planned":
          return x.plannedHours
          break;
        case "implemented":
          return x.implementedHours
          break;
        default:
          break;
      }
    })
  };
  const series = [
    {
      name: graphType === 0 ? "Custo Contratado" : "Horas Contratadas",
      data: graphType === 0 ? costGraph(projectImplemented, "budget") : hourGraph(projectImplemented, "budget")
    },
    {
      name: graphType === 0 ? "Custo Planejado" : "Horas Planejadas",
      data: graphType === 0 ? costGraph(projectImplemented, "planned") : hourGraph(projectImplemented, "planned")
    },
    {
      name:  graphType === 0 ? "Custo Alocado" : "Horas Alocadas",
      data: graphType === 0 ? costGraph(projectImplemented, "implemented") : hourGraph(projectImplemented, "implemented")
    }
  ]

  const options = {
    chart: {
      height: 500,
      type: 'line',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      }
    },
    colors: ['#82B536', '#F5CD47', '#036CBF'],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight'
    },
    title: {
      text: '',
      align: 'left'
    },
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5
      },
    },
    xaxis: {
      categories: graphType === 0 ? costGraph(projectImplemented, "name") : hourGraph(projectImplemented, "name")
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          if (graphType === 0) 
            return formatCurrency(val);
          else 
            return `${val}h`
        }
      },
      min: 0,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
    }
  }

  return (
    <div className={styles.container}>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height={300}
          width="100%"
        />
      </div>
      <div id="html-dist"></div>   
    </div>
  );
};
